import type {Collection} from 'services/series/types';
import {mapGetCollectionDto} from 'services/series';
import type {GetTokens} from './types';
import type {Schemas} from './dto.generated';
import {exceptionToPromiseReject} from './exceptionToPromiseReject';
import {httpGet} from './http/ebba';

export const getCollection = (
  id: string,
  getTokens: GetTokens,
  mock?: boolean,
): Promise<Collection> => {
  return exceptionToPromiseReject(() =>
    httpGet<Schemas.SeriesWithRelationsDto>({
      subdir: 'series/{id}',
      subdirParams: {id},
      mock,
      getTokens,
    }).then(mapGetCollectionDto),
  );
};
